import InboomaBaseModel from "./InboomaBaseModel";
import Contingents from "../collections/Contingents";
import { _ } from "../../vendor";

export default InboomaBaseModel.extend({
  urlRoot: "/locations",

  initialize() {
    this.setChildren();
    this.initializeFakeFields();
    this.on("change:pre_booking_time", (that) => {
      that.initializeFakeFields();
    });
  },

  setChildren() {
    this.set("contingents", new Contingents(this.get("contingents")));
  },

  initializeFakeFields() {
    let _pre_booking_time = parseInt(this.get("pre_booking_time"));
    if (_pre_booking_time != 0 && (_pre_booking_time != "" || _.isNaN(_pre_booking_time))) {
      if (_pre_booking_time >= 86400) {
        this.set("_rate", 86400);
        this.set("_amount", _pre_booking_time / 86400);
      } else if (_pre_booking_time >= 3600) {
        this.set("_rate", 3600);
        this.set("_amount", _pre_booking_time / 3600);
      } else if (_pre_booking_time >= 60) {
        this.set("_rate", 60);
        this.set("_amount", _pre_booking_time / 60);
      }
    }
  },

  defaults: {
    id: "",
    name: "",
    description: "",
    longitude: "",
    latitude: "",
    contingents: [],
    geofence: "0",
    pre_booking_time: "",
    availability_rules: "contingents",
    availability_checkin: "reservation-only",
    location_addres: [],
    fe_visible: true,
    oneway: false,
    created: "",
    modified: "",
    deleted: "",
    ssid: "",
    _rate: 60,
    _amount: "",
  },

  _rbac: {
    // Logic not complete; see LocationsView.js
    admin: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    user: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    manager: {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
    "booking-manager": {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
    "manager-location": {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
    mediator: {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
    garage_staff: {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
    guide: {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
  },
});
